// extracted by mini-css-extract-plugin
export default {"root":"ReviewRating_root__YN8pY","starWrap":"ReviewRating_starWrap__4LekD","starHalf":"ReviewRating_starHalf__FtLQy"};